import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=2efec5db&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=2efec5db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efec5db",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2efec5db')) {
      api.createRecord('2efec5db', component.options)
    } else {
      api.reload('2efec5db', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=2efec5db&scoped=true&", function () {
      api.rerender('2efec5db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2My6bZ5o4m28f/JS/comp/DocBox.vue"
export default component.exports